import { memo, useEffect, useState } from "react";
import EventV2LeftRail from "./EventV2LeftRail";

const EventV2SidebarShell = ({ activeId, open: openProp, onOpenChange }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = typeof openProp === "boolean";
  const open = isControlled ? openProp : internalOpen;

  const setOpen = (next) => {
    if (!isControlled) setInternalOpen(next);
    if (onOpenChange) onOpenChange(next);
  };

  useEffect(() => {
    document.body.classList.toggle("event-sidebar-open", open);
    return () => document.body.classList.remove("event-sidebar-open");
  }, [open]);

  useEffect(() => {
    setOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeId]);

  const closeSidebar = () => setOpen(false);

  return (
    <>
      <button
        type="button"
        className="event-sidebar-fab d-lg-none"
        aria-label="Open navigation menu"
        onClick={() => setOpen(true)}
      >
        <i className="bi bi-list" aria-hidden="true" />
        <span>Menu</span>
      </button>

      <div className="col-12 col-lg-3 col-xl-3 event-split-col">
        <EventV2LeftRail activeId={activeId} />
      </div>

      {open && (
        <>
          <button
            type="button"
            className="event-sidebar-backdrop"
            aria-label="Close navigation menu"
            onClick={closeSidebar}
          />
          <div
            className="event-sidebar-drawer event-sidebar-drawer--hub is-open"
            role="dialog"
            aria-modal="true"
            aria-label="Event menu"
          >
            <div className="event-sidebar-drawer-head">
              <div className="event-sidebar-drawer-title">
                <i className="bi bi-list" aria-hidden="true" />
                <span>Event Menu</span>
              </div>
              <button
                type="button"
                className="event-sidebar-drawer-close"
                aria-label="Close menu"
                onClick={closeSidebar}
              >
                <i className="bi bi-x-lg" aria-hidden="true" />
              </button>
            </div>
            <div className="event-sidebar-drawer-body">
              <EventV2LeftRail
                activeId={activeId}
                onNavigate={closeSidebar}
                menuOnly
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default memo(EventV2SidebarShell);
